import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ReactionEvent } from './ReactionCfg';

import styles from './ReactionsPlayer.module.less';
import { Observable, Subscription } from 'rxjs';

type AnimationState = {
	char: string;
	time: number;
	left: number;
	delay1: number;
	delay2: number;
	reverseSpin: string;
}

const animationTime = 20000;
const maxVisible = 10;

@Component({
	selector: 'reactions-player',
	host: {
		'[class]': 'styles.root'
	},
	template: `
	@for(emoji of emojis; track emoji) {
		<div [ngClass]="styles.floatWrap"
			[style.left.%]="emoji.left"
			[style.animationDelay.ms]="emoji.delay1">
			<div [ngClass]="styles.rotateWrap"
				[style.animationDelay.ms]="emoji.delay2"
				[style.animationDirection]="emoji.reverseSpin"
			>
				<span [ngClass]="styles.emoji">{{emoji.char}}</span>
			</div>
		</div>
	}
	`,
    standalone: false
})
export class ReactionsPlayerComponent implements OnInit, OnDestroy {
	@Input() public reactions$: Observable<ReactionEvent>;
	@Input() public isHidden: boolean;

	public emojis: AnimationState[] = [];
	public sub: Subscription;

	public readonly styles = styles;

	public ngOnInit(): void {
		this.sub = this.reactions$.subscribe(e => {
			if(this.isHidden ||
				maxVisible < this.emojis.reduce((sum, emoji) => sum + (emoji.char === e.char ? 1 : 0), 0)) {
				return;
			}

			for(let i=0; i<e.count; i++) {
				this.addEmoji(e.char);
			}
			this.scheduleCleanup();
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if(changes.isHidden) {
			window.clearTimeout(this.timer);
			this.timer = null;
			this.runCleanup();
		}
	}

	public ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	private addEmoji(char: string): void {
		this.emojis.push({
			char,
			time: Date.now(),
			left: Math.random() * 100,
			delay1: -Math.floor(Math.random() * 1000),
			delay2: -Math.floor(Math.random() * 10000),
			reverseSpin: Math.random() > 0.5 ? 'reverse' : 'normal'
		});
	}

	private timer: number;
	private scheduleCleanup(): void {
		if(this.timer) {
			return;
		}
		this.timer = window.setTimeout(() => {
			this.timer = undefined;
			this.runCleanup();
		}, animationTime);
	}

	private runCleanup(): void {
		if(this.isHidden) {
			this.emojis = [];
			return;
		}

		const cutoffTime = Date.now() - animationTime;
		this.emojis = this.emojis.filter(e => e.time > cutoffTime);
		if(this.emojis.length) {
			this.scheduleCleanup();
		}
	}

}
